// @ts-ignore
import { generateActions } from './utils'
import { createAction } from 'redux-actions'

const accountDefinition = {
  read: ['id'],
  fetchAccount: ['id'],
  updateAccount: ['id', 'data'],
  updateAccountContact: ['id', 'data'],
  updateAccountAddress: ['id', 'data'],
  loadInvoices: ['id'],
}

export const accountActions = generateActions(['ACCOUNT'], accountDefinition)

// Simple actions (no saga needed)
export const SET_CONNECTED_ACCOUNT = 'ACCOUNT.SET_CONNECTED_ACCOUNT'
export const SET_ME_LOADING = 'ACCOUNT.SET_ME_LOADING'
export const CLEAR_ME = 'ACCOUNT.CLEAR_ME'

export const setConnectedAccount = createAction(SET_CONNECTED_ACCOUNT)
export const setMeLoading = createAction(SET_ME_LOADING)
export const clearMe = createAction(CLEAR_ME)

export default accountActions
